/**
 * 算价系统逻辑说明组件
 */

import React from 'react';
import { Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const PricingLogicExplanation: React.FC = () => {
    return (
        <div style={{
            marginTop: 8,
            padding: '10px 16px',
            background: '#fffbe6',
            border: '1px solid #ffe58f',
            borderRadius: 4
        }}>
            <Space align="start">
                <InfoCircleOutlined style={{ color: '#faad14', marginTop: 4, fontSize: 16 }} />
                <div style={{ fontSize: 13, color: '#666' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 6, fontSize: 14 }}>
                        算价系统逻辑说明:
                    </div>
                    <div style={{ marginBottom: 3 }}>
                        1. <b>汇率转换</b> = 采购成本(¥) / 汇率 + 头程运费(¥) / 汇率 = 成本($)
                    </div>
                    <div style={{ marginBottom: 3 }}>
                        2. <b>完税成本</b> = 成本($) + 成本($) × 关税率 + 头程运费($)
                    </div>
                    <div style={{ marginBottom: 3 }}>
                        3. <b>固定成本</b> = 完税成本 + FBA配送费 + 当前季节仓储费
                    </div>
                    <div style={{ marginBottom: 3 }}>
                        4. <b>变动成本率</b> = 佣金率 + 退货率 + 其他成本率
                    </div>
                    <div style={{ marginBottom: 3 }}>
                        5. <b>反推售价</b> = 固定成本 / (1 - 变动成本率 - 目标利润率)
                    </div>
                    <div>
                        6. <b>计算利润率</b> = (售价 × (1 - 变动成本率) - 固定成本) / 售价
                    </div>
                </div>
            </Space>
        </div>
    );
};
